import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Row, Col, Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import AvatarUploader from '../AvatarUploader';
import MembersList from '../Members/MembersList';

class CreateTeam extends Component {
  constructor() {
    super();
    this.state = {
      avatar: '',
      name: '',
    };
  }

  componentWillMount() {
    const { team, route } = this.props;

    if (route.type === 'create' && team && team.id) {
      this.setState({ name: team.name, avatar: '' }, () => {
        this.setState({ avatar: team.avatar });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status, route, router } = nextProps;

    if (
      this.props.status === actionTypes.TEAM_CREATE_REQUEST ||
      this.props.status === actionTypes.TEAM_UPDATE_REQUEST
    ) {
      if (
        status === actionTypes.TEAM_CREATE_SUCCESS ||
        status === actionTypes.TEAM_UPDATE_SUCCESS
      ) {
        if (route.type === 'create') {
          router.push('/create/select-agreement');
        } else if (route.type === 'create-deal') {
          router.push('/create-deal/agreement-standalone');
        } else {
          router.push(`/teams`);
        }
      } else if (
        status === actionTypes.TEAM_CREATE_ERROR ||
        status === actionTypes.TEAM_UPDATE_ERROR
      ) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try to again. If this error persists, please contact us.'
        );
      }
    }
  }

  handleNext(e) {
    const { name } = this.state;

    this.props.hideAlert();
    if (name === '') {
      this.props.alert('error', 'Please give your team a name.');
      return false;
    } else {
      this.save(e);
    }
  }

  handleUpload(file) {
    if (file && file.url) {
      this.setState({ avatar: file.url });
    } else {
      this.setState({ avatar: '' });
    }
  }

  save(e) {
    const { members, profile, team, route } = this.props;
    e.preventDefault();

    let data = {
      name: this.state.name,
      avatar: this.state.avatar,
      user: profile.id,
    };

    if (members && members.length > 1) {
      if (route.type === 'create') {
        this.props.assign('newTeam', true);
      }

      if (team && team.id) {
        this.props.updateTeam(team.id, data);
      } else {
        data.members = members.map((member) => ({
          name: member.user_info.name,
          full_name: member.user_info.name,
          email: member.user_info.email.toLowerCase(),
          company_name: member.user_info.company_name,
          user_title: member.user_info.user_title,
          use_company_name: member.user_info.use_company_name,
          avatar: member.user_info.avatar,
          role_ids: member.role_ids,
          ownership_type_id: member.ownership_type_id,
          work_for_hire: member.work_for_hire,
        }));
        this.props.createTeam(data);
      }
    } else {
      let canCreateOwnMember =
        _.findIndex(
          members,
          (member) => member.user_info.email === profile.email
        ) === -1;

      if (profile.subscription_plan === 'pro-annual') {
        canCreateOwnMember = false;
      }

      if (canCreateOwnMember) {
        this.props.alert(
          'error',
          'A team must contain at least 2 people, including yourself.'
        );
      } else {
        this.props.alert('error', 'A team must contain at least 2 people.');
      }
    }
  }

  renderNavigation(onTop) {
    const disabled = this.props.status === actionTypes.TEAM_CREATE_REQUEST;

    if (onTop) {
      if (this.props.route.type === 'create') {
        return (
          <div className="step-nav top">
            <NavButtons
              direction="back"
              disabled={disabled}
              prev={() => this.props.router.push('/create/select-team')}
            />
          </div>
        );
      } else if (this.props.route.type === 'create-deal') {
        return (
          <div className="step-nav top">
            <NavButtons
              direction="back"
              disabled={disabled}
              prev={() => this.props.router.push('/create-deal')}
            />
          </div>
        );
      } else {
        return null;
      }
    } else {
      if (this.props.route.type === 'create') {
        return (
          <div className="step-nav">
            <NavButtons
              direction="back"
              disabled={disabled}
              prev={() => this.props.router.push('/create/select-team')}
            />
            <NavButtons
              direction="next"
              disabled={disabled}
              next={(e) => this.handleNext(e)}
            />
          </div>
        );
      } else if (this.props.route.type === 'create-deal') {
        return (
          <div className="step-nav">
            <NavButtons
              direction="back"
              disabled={disabled}
              prev={() => this.props.router.push('/create-deal')}
            />
            <NavButtons
              direction="next"
              disabled={disabled}
              next={(e) => this.handleNext(e)}
            />
          </div>
        );
      } else {
        return (
          <div className="step-nav">
            <div></div>
            <button type="submit" disabled={disabled}>
              Save
            </button>
          </div>
        );
      }
    }
  }

  render() {
    return (
      <div className="create-team">
        <Heading text="Create your team" />
        <p className="text-gray text-center">
          Add all of the collaborators that will need to sign your agreement
          here, including yourself.
        </p>
        <Form onSubmit={(e) => this.save(e)}>
          <Row>
            <Col md={3}>
              <div className="team-photo text-center">
                <AvatarUploader
                  size="120"
                  image={this.state.avatar}
                  onUpload={(file) => this.handleUpload(file)}
                />
                <span className="text-gray">Add/edit team photo</span>
              </div>
            </Col>
            <Col md={7}>
              <div className="team-name">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Click here to give your team a name"
                    value={this.state.name}
                    onChange={(e) => this.setState({ name: e.target.value })}
                    required
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={9} mdOffset={3}>
              <MembersList type={this.props.route.type} />
            </Col>
          </Row>
          {this.renderNavigation(false)}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  step: state.create.step,
  fields: state.create.fields,
  members: state.users.members,
  profile: state.profile,
  status: state.teams.status,
  team: state.teams.selectedTeam,
});

const mapDispatchToProps = (dispatch) => ({
  assign: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
  createTeam: (data) => {
    dispatch(actions.createTeam(data));
  },
  updateTeam: (teamId, data) => {
    dispatch(actions.updateTeam(teamId, data));
  },
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateTeam);



// WEBPACK FOOTER //
// src/components/Teams/CreateTeam.jsx